export class CourseDto {
  id: number;
  title: string;
  courseHours: number;
  courseMinutes: number;
  courseType: string;
  supportUrl: string;
  supportPath: string;
  moduleId: number;
}
